import React from "react";
import FormLabel from "./styled/FormLabel";
import InputField from "./styled/InputField";
import CountryDropdown from "./styled/CountryDropdown ";
import {
  faUser,
  faEnvelope,
  faPhone,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import GenderRadioForm from "./styled/GenderRadioForm";
import SizeRadioForm from "./styled/SizeRadioForm";

const PersonalInfoForm = ({
  name,
  setName,
  lastname,
  setLastname,
  phone,
  setPhone,
  email,
  setEmail,
  confirmEmail,
  setConfirmEmail,
  address,
  setAddress,
  city,
  setCity,
  country,
  setCountry,
  countries,
  gender,
  setGender,
  size,
  setSize,
}) => {
  const handleLetterInputChange = (inputValue, setter) => {
    const regex = /^[a-zA-ZÀ-ÿ\s]*$/;
    if (regex.test(inputValue)) {
      setter(inputValue);
    }
  };

  const handleEmailInputChange = (inputValue, setter) => {
    const regex = /^[a-zA-Z0-9._%+-@]*$/;
    if (regex.test(inputValue)) {
      setter(inputValue);
    }
  };

  return (
    <>
      <FormLabel>Nombre</FormLabel>
      <InputField
        icon={faUser}
        type="text"
        placeholder="Ingresar nombres"
        value={name}
        onChange={(e) => handleLetterInputChange(e.target.value, setName)}
        maxLength={50}
      />
      <FormLabel>Apellido</FormLabel>
      <InputField
        icon={faUser}
        type="text"
        placeholder="Ingresar apellidos"
        value={lastname}
        onChange={(e) => handleLetterInputChange(e.target.value, setLastname)}
        maxLength={50}
      />
      <GenderRadioForm gender={gender} setGender={setGender} />
      <SizeRadioForm size={size} setSize={setSize} />{" "}
      <FormLabel>Teléfono</FormLabel>
      <InputField
        icon={faPhone}
        type="tel"
        placeholder="Ingresar teléfono"
        mask="(999) 999-9999"
        maskChar={null}
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
      <FormLabel>Correo electrónico</FormLabel>
      <InputField
        icon={faEnvelope}
        type="text"
        placeholder="Ingresar correo electrónico"
        value={email}
        onChange={(e) => handleEmailInputChange(e.target.value, setEmail)}
        maxLength={50}
      />
      <InputField
        icon={faEnvelope}
        type="text"
        placeholder="Confirmar correo electrónico"
        value={confirmEmail}
        onChange={(e) =>
          handleEmailInputChange(e.target.value, setConfirmEmail)
        }
        maxLength={50}
      />
      <FormLabel>Dirección</FormLabel>
      <InputField
        icon={faLocationDot}
        type="text"
        placeholder="Ingresar dirección"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        maxLength={120}
      />
      <InputField
        icon={faLocationDot}
        type="text"
        placeholder="Ingresar ciudad"
        value={city}
        onChange={(e) => handleLetterInputChange(e.target.value, setCity)}
        maxLength={120}
      />
      <CountryDropdown
        value={country}
        onChange={(e) => setCountry(e.target.value)}
        countries={countries}
      />
    </>
  );
};

export default PersonalInfoForm;
